import React, { useState, useEffect } from "react";
import { fetchTopAshaData } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Avatar } from "primereact/avatar";
import GetAreaId from '../../../../Shared/Utils/getAreaId';
import * as masterSelectors from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import * as dashboardSelector from "../../../../Store/Dashboard/DashboardSelectors"
import "./TopFiveAsha.scss";
import ArrowRight from "../../../../Assets/Property 1=Arrow Right.png";
import PropTypes from 'prop-types';
import NoRecordFound from "../../../../Shared/Component/NoRecordFound/NoRecordFound";
import { useTranslation } from 'react-i18next';
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";

const TopFiveAsha = ({ onAshaSelect, ashaDetails }) => {
  const { t } = useTranslation();
  const {selectedLanguageId}  = useLanguage();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const topPerformerData = useSelector(masterSelectors.getTopPerformerData);
  const [selectedAsha, setSelectedAsha] = useState("ASHA");
  const areaTypeName = useSelector(dashboardSelector.getGlobalAreaType);
  const roles = ["ASHA", "ANM"];
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.toLocaleString("default", { month: "short" });
  const areaid = GetAreaId(areaTypeName) ;

  const sortType = "highestToLowest";
  const roles_user = sessionStorage.getItem('userRole');
  useEffect(() => {
    dispatch(fetchTopAshaData(areaid, month, year, selectedLanguageId,sortType,roles_user));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch,areaid,selectedLanguageId,month,year,roles_user]);
  useEffect(() => {
    if (topPerformerData && topPerformerData.length > 0) {
      const filteredData = topPerformerData.slice(0, 5);
      setData(filteredData);
    }
    else {
      setData([]);
    }
  }, [topPerformerData,selectedLanguageId,areaTypeName]);
  return (
      <div className="flex flex-column lg:gap-2 sm:gap-2 ml-2 bg-white p-3 asha-detail">
        <div className="flex align-items-center justify-content-between">
          <div className=" text-base text-blue-900 font-semibold">
            {" "}
            {t('Top5PerAshas')}{" "}
          </div>
          <div className="ml-3">
            <Dropdown
              data-testid="drop"
              value={selectedAsha}
              onChange={(e) => setSelectedAsha(e.value)}
              options={roles}
              className="cockpit-dropdown"
              disabled
            />
          </div>
          <div className="ml-5">
            <img
              className="ml-3"
              src={ArrowRight}
              style={{ height: "1.2rem", width: "1.2rem", cursor: 'pointer' }}
              alt=""
              onClick={ashaDetails}
              onKeyDown={ashaDetails}
            />
          </div>
        </div>
        <div className="flex align-items-center justify-content-start">
          <div className="text-sm text-blue-900">{t('currentmonth')}</div>
        </div>
        <div className="grid">
          {data && data.length !== 0 ?
            data.map((item, index) => (
              <div className={` ${index === 4 ? "col-12" : "col-6"} `} key={item.ashaid}>
                <div
                  className="asha-display text-center p-2 border-round-md font-bold"
                  onClick={() => onAshaSelect(item.ashaid, item.ashaName)}
                  onKeyDown={() => onAshaSelect(item.ashaid,item.ashaName)}
                >
                  <Avatar
                    label={item.ashaName.charAt(0)}
                    style={{height:"2.25rem", width:"2.25rem"}}
                    shape="circle"
                  />
                  <div className="text-blue-900 font-normal text-base">
                    {item.ashaName}
                  </div>
                  <div className="font-light text-sm">
                    {item.districtName}
                  </div>
                </div>
              </div>
          )) : <NoRecordFound/>}
        </div>
      </div>
  );
};

TopFiveAsha.propTypes = {
  onAshaSelect: PropTypes.func.isRequired,
  ashaDetails: PropTypes.func.isRequired
};

export default TopFiveAsha;
